import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, Target, Users } from "lucide-react";
import { PROMISES } from "@/content/landing";
import Reveal from "./Reveal";

const ICONS = { Users, Target, ShieldCheck };

export default function Promises() {
  return (
    <section className="landing-section" id="engagements">
      <Reveal className="section-intro">
        <span className="eyebrow">{PROMISES.eyebrow}</span>
        <h2>{PROMISES.title}</h2>
        <p className="section-lead" style={{ marginTop: 14 }}>{PROMISES.lead}</p>
      </Reveal>
      <div className="testimonials">
        {PROMISES.items.map((item, i) => {
          const Icon = ICONS[item.icon];
          return (
            <Reveal key={item.title} delay={i * 0.07} className="testimonial">
              <span className="feature-icon"><Icon size={15} /></span>
              <div>
                <h3 style={{ fontSize: 15, marginBottom: 7 }}>{item.title}</h3>
                <p style={{ fontSize: 13, lineHeight: 1.6, color: "#5f665c", margin: 0 }}>{item.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
      <Reveal delay={0.1}>
        <Link to={PROMISES.cta.to} className="landing-link" style={{ marginTop: 22, display: "inline-flex" }}>
          {PROMISES.cta.label}<ArrowRight size={13} />
        </Link>
      </Reveal>
    </section>
  );
}
